/*  nav.component acts like both nav and root stack  */
import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { AuthContext } from './context';
import { useSelector } from 'react-redux';
import { Switch, Route } from "react-router-dom";
//import { ClipboardSharp } from 'react-ionicons';
import { FaClipboard } from "react-icons/fa";
import { Button, Modal } from 'react-bootstrap';
import Home from './home.component';  /* Routes */
import Login from './login.component';
import Register from './register.component';
import Forgot from './forgot.component';
import Product from './product.component';
import CreateProduct from './createProduct.component';
import ProductDetail from './productDetail.component';
import BootstrapCard from './bootstrapCard.component';
import DataLoggerBriefScreen from './dataLoggerBriefScreen.component';
import GraphScreen from './graph.component';
import DateRangePickerScreen from './dateRangePickerScreen.component';
import PageNotFound from './pageNotFound.component';
import Contact from './contact.component';


const Nav = () => {

    const { signOut } = React.useContext(AuthContext);
    const loginState = useSelector(state => state.currentLogin);

    const [showModal, setShowModal] = useState(false);
    const handleModalClose = () => {setShowModal(false)}
    const handleModalShow = () => {setShowModal(true)}

    let menubarOptions;
    if(loginState.isLoggedIn){  //menubarOptions for loggedIn user
        menubarOptions = (<ul className="navbar-nav ml-auto">
                    {/* <li className="nav-item"><Link to={`/createProduct`} className="nav-link"><strong>Create Product</strong></Link></li> */}
                    {/* <li className="nav-item"><Link to={`/dateRangePickerScreen`} className="nav-link"><strong>DateRange</strong></Link></li> */}
                    <li className="nav-item"><Link to={`/`} className="nav-link"><strong>Map</strong></Link></li>
                    <li className="nav-item"><Link to={`/dataLoggerBrief`} className="nav-link"><strong>Brief</strong></Link></li>
                    <li className="nav-item"><Link to={`/graph`} className="nav-link"><strong>Graph</strong></Link></li>
                    <li className="nav-item"><Link to={`/register`} className="nav-link"><strong>Register</strong></Link></li>
                    <li className="nav-item"><Link to={`/`} onClick={ ()=> {handleModalShow();}} className="nav-link"><strong>Logout</strong></Link></li>
                    </ul>
                )

    }else{  //menubarOptions for Non loggedIn user
        menubarOptions = (<ul className="navbar-nav ml-auto">
                    <li className="nav-item"><Link to={`/login`} className="nav-link"><strong>Login</strong></Link></li>
                    
                    </ul>
                )
    }

    return(
        <>
            <Modal show={showModal} onHide={ ()=> {handleModalClose();}}>
                <Modal.Header closeButton>
                <Modal.Title>Confirm Logout</Modal.Title>
                </Modal.Header>
                <Modal.Body>Are you sure you want to Logout?</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={ ()=> {handleModalClose();}}>Cancel</Button>
                <Button variant="primary" onClick={ ()=> {signOut(); handleModalClose();}}>Confirm</Button>
                </Modal.Footer>
            </Modal>

            <nav className="navbar navbar-expand navbar-light fixed-top">
                <div className="container-fluid">
                <Link className="navbar-brand" to={`/`}>
                    <FaClipboard /> <strong>Viufy</strong>
                </Link>
                <span className="navbar-text">
                <div className="collapse navbar-collapse">
                    {menubarOptions}
                </div>
                </span>
                </div>
            </nav>

            <Switch>
                <Route exact path="/" component={Home} />
                <Route path="/login" component={Login} />
                <Route path="/register" component={Register} />
                <Route path="/forgot" component={Forgot} />
                <Route path="/product" component={Product} />
                <Route path="/createProduct" component={CreateProduct} />
                <Route path="/productDetail/:id" exact component={ProductDetail} />
                <Route path='/bootstrapCard' component={BootstrapCard} />
                <Route path='/dataLoggerBrief' component={DataLoggerBriefScreen} />
                <Route path='/graph' component={GraphScreen} />
                <Route path='/dateRangePickerScreen' component={DateRangePickerScreen} />
                <Route path='/contact' component={Contact} />
                <Route><PageNotFound /></Route> {/* Render this component if invalid URL is called */}
            </Switch>
        </>
    );
}
export default Nav;
